// tslint:disable
export var EADataDepth;
(function (EADataDepth) {
    // None
    EADataDepth[EADataDepth["None"] = 0] = "None";
    // Primary
    EADataDepth[EADataDepth["Primary"] = 1] = "Primary";
    // Secondary
    EADataDepth[EADataDepth["Secondary"] = 2] = "Secondary";
    // Tertiary
    EADataDepth[EADataDepth["Tertiary"] = 3] = "Tertiary";
    // Quaternary
    EADataDepth[EADataDepth["Quaternary"] = 4] = "Quaternary";
    // Quinary
    EADataDepth[EADataDepth["Quinary"] = 5] = "Quinary";
})(EADataDepth || (EADataDepth = {}));
EADataDepth['NONE'] = 0;
EADataDepth['PRIMARY'] = 1;
EADataDepth['SECONDARY'] = 2;
EADataDepth['TERTIARY'] = 3;
EADataDepth['QUATERNARY'] = 4;
EADataDepth['QUINARY'] = 5;
//# sourceMappingURL=EADataDepth.js.map